import { LocationState, Path } from 'history';
import { scrollToTop } from '../../common/helpers/viewport';
import useRouter from 'AppShell/hooks/useRouter';
import { NavigationPush, RedirectWithBannerPayload } from 'AppShell/appshell_types';
import { useCallback } from 'react';

const useAppshellHistoryPush = (validateIsExternalLink: (p: Path) => boolean) => {
    const router = useRouter();

    const appshellHistoryPush: NavigationPush = useCallback(
        (
            to: Path,
            replace?: boolean,
            state?: LocationState | RedirectWithBannerPayload,
            preventScroll: boolean = false
            // eslint-disable-next-line max-params
        ) => {
            const isExternalLink = validateIsExternalLink(to);
            // Check if we want to push a state, so that we do not do service navigation in remote header
            if (!state && (isExternalLink || router.disableClientsideNavigation)) {
                if (replace) {
                    window.location.replace(to);
                } else {
                    window.location.assign(to);
                }
                return;
            }

            if (!state && !preventScroll) {
                scrollToTop();
            }

            if (replace) {
                router.history.replace(to, state);
            } else {
                router.history.push(to, state);
            }
        },
        [router.disableClientsideNavigation, router.history, validateIsExternalLink]
    );

    return appshellHistoryPush;
};

export default useAppshellHistoryPush;
